import React from 'react';
import styled from 'styled-components';
import { Tooltip } from 'react-tippy';
import {
  Control,
  ControlLabel,
  ControlFieldInput,
  ControlError,
} from './styled/Controls';
import { fontFamilyRegular } from './styled/Fonts';
import Colours from './styled/Colours';

const ControlField = styled(ControlFieldInput as any)<{
  hasError: boolean;
  hasTip: boolean;
}>`
  ${({ hasTip }) =>
    hasTip &&
    `
    input {
      padding-right: 50px;
    }
  `}
`;

const TipContainer = styled.div`
  display: block;
  position: absolute;
  right: 10px;
  top: 50%;
  margin-top: -12px;
  width: 1.5rem;
  height: 1.5rem;
`;

const TipButton = styled.button`
  border-radius: 32px;
  background: none;
  border: none;
  color: ${Colours.lightGrey};
  line-height: 1;
  margin: 0;
  padding: 1px 0 0 0;
  height: 1.5rem;
  width: 1.5rem;
  transition: box-shadow 0.3s ease-in-out;

  i {
    font-size: 24px;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 0.25rem rgba(8, 132, 252, 0.3);
  }
`;

const TipContent = styled.div`
  ${fontFamilyRegular};
  max-width: 160px;
  text-align: left;
`;

type Props = {
  label: string;
  tip: string;
  tipClick: () => void;
  type?: string;
  required?: boolean;
  field: { name: string };
  form: any;
};

const TextInput = ({
  field,
  label,
  tip,
  tipClick,
  type,
  required,
  form: { touched, errors },
  ...props
}: Props) => {
  const hasError = touched[field.name] && errors[field.name];
  return (
    <Control className="input">
      <ControlLabel>
        <label htmlFor={field.name}>{label}</label>
        {required && <span className="input__required"> *</span>}
      </ControlLabel>
      <ControlField hasError={hasError} hasTip={!!tip}>
        <input id={field.name} type={type} {...field} {...props} />
        {tip && (
          <TipContainer>
            {/* @ts-ignore */}
            <Tooltip
              html={<TipContent>{tip}</TipContent>}
              animation="fade"
              arrow
              arrowSize="small"
              position="top"
              size="small"
              title={tip}
              trigger="focus"
              distance={16}
            >
              <TipButton
                type="button"
                onClick={tipClick}
                aria-label="Help tooltip"
              >
                <i className="icon-help-circle" aria-hidden />
              </TipButton>
            </Tooltip>
          </TipContainer>
        )}
      </ControlField>
      {hasError && (
        <ControlError id={`validation-${field.name}`}>
          {errors[field.name]}
        </ControlError>
      )}
    </Control>
  );
};
TextInput.defaultProps = {
  type: 'text',
  required: false,
};

export default TextInput;
